export default __webpack_public_path__ + "static/media/device_type_pc.e76b8d20.svg";